<template>
  <div
    :id="data.id"
    class="bg-gray-lighten3 pb-10 pt-20 text-white md:pb-14 md:pt-28"
  >
    <div
      v-lazy-background="backgroundImage"
      class="container min-h-[606px] overflow-hidden bg-cover bg-bottom bg-no-repeat py-14 md:min-h-0 md:rounded-lg md:bg-right md:py-[140px] md:pl-28"
    >
      <div
        v-if="data.title"
        class="title mb-10 text-center text-xl uppercase leading-none md:whitespace-pre-line md:text-left md:text-3xl md:leading-none"
        v-html="data.title"
      />

      <div
        class="mx-auto flex w-[280px] max-w-full flex-col gap-4 sm:w-auto sm:flex-row sm:justify-center md:justify-start"
      >
        <UiButton
          v-if="data.button1 && data.button1.text && data.button1.url"
          :to="data.button1.link"
          :download="data.button1.download"
          :target="data.button1.target"
          :block="!isBiggerSm"
          inverted
          size="md"
        >
          <span v-html="data.button1.text" />
        </UiButton>

        <UiButton
          v-if="data.button2 && data.button2.text && data.button2.url"
          :to="data.button2.link"
          :download="data.button2.download"
          :target="data.button2.target"
          :block="!isBiggerSm"
          variant="secondary"
          inverted
          size="md"
        >
          <span v-html="data.button2.text" />
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');
const { isBiggerThanBreakpoint: isBiggerMd } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(
    isBiggerMd.value
      ? props.data.backgroundImageDesktop
      : props.data.backgroundImageMobile,
  ),
);
</script>
